module.exports = "./img/6416b58f14e07ed7ccddf6c2363bb695.png";